
import { defineComponent, ref, PropType } from 'vue'
import InputCheck from '@/components/inputs/InputCheck.vue'
import { getGoogleMapsRoutes } from '@/api/tripply/directions'
import { Route, RouteLiveState } from '@/api/tripply/models'
import * as Tripply from '@/api/tripply/live'

export default defineComponent({
  name: 'LiveControls',
  components: { InputCheck },
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    liveState: {
      type: Object as PropType<RouteLiveState>,
      required: true
    }
  },
  setup(props) {
    
    const outsideApp = ref(false)
    const navigate = ref(false)

    async function next() {    
      if (navigate.value) {
        outsideApp.value = !props.liveState.driving
      } 
      getGoogleMapsRoutes(props.route.places)
      Tripply.nextPlace(props.route.id, navigate.value)
    } 

    return { next, outsideApp, navigate }
  }
})
